import { useEffect } from 'react';

export function useAsyncEffect(callback, destroy, dependencies = []) {
	useEffect(
		() => {
			callback();

			if (typeof destroy === 'function') return destroy;
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		destroy instanceof Array ? destroy : dependencies,
	);
}
